<template>
  <div class="study-info">
    <!-- <title-bar :title="'我的学习'" :showAll="false"></title-bar> -->
    <div class="progress-view" :class="'progress-stop'">
      <div class="left">
        <div class="title-container">
          <div class="heart">
            <img class="heart-img" src="../../../assets/images/home/heart@2x.png" alt="" />
          </div>
          <div class="title">
            {{ overviewInfo && overviewInfo.displayName }}
          </div>
        </div>
        <div class="student-text">
          开启时间：{{ overviewInfo.openTime || '暂无' }}
        </div>
      </div>
      <div class="switch-path-btn" @click="openMap">
        <div class="switch-path-btn-text">切换地图</div>
      </div>
    </div>
    <div class="study-progress-container">
      <div class="study-progress-tips-container">
        <div class="dot"></div>
        <div class="text" v-if="stateProgress < 100">
          你当前有未完成的课程
        </div>
        <div class="text" v-if="stateProgress == 100 || stateProgress > 100">
          你已完成所有的课程
        </div>
      </div>
      <div class="go-study-btn" v-if="stateProgress < 100">
        <div class="go-study-text" @click="openStudyPopup">去学习</div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from '../../../components/TitleBar.vue'
export default {
  name: 'StudyInfo',
  components: {
    TitleBar
  },
  props: {
    overviewInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    stateProgress: {
      type: Number,
      default: 0
    }
  },
  methods: {
    openMap() {
      this.$emit('openMap')
    },
    openStudyPopup() {
      this.$emit('openStudyPopup')
    }
  }
}
</script>

<style lang="less" scoped>
.study-info {
  width: 100%;
  .progress-view {
    width: 100%;
    height: 75px;
    background: #ffffff;
    display: flex;
    // align-items: center;
    justify-content: space-between;
    border-radius: 12px;
    box-shadow: 0px 4px 26px 0px rgba(0,0,0,0.08);
    position: relative;
    margin-top: 10px;
    margin-bottom: 13px;
    .left {
      width: calc(100% - 95.5px);
      padding: 16px 0 16px 12px;
      font-family: PiSource Han Sans CN, Source Han Sans CN;
      .title-container {
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        .title {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          height: 22px;
          font-size: 16px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 600;
          color: #333333;
          line-height: 22px;
        }
        .heart {
          width: 17px;
          height: 17px;
          margin-right: 3px;
          .heart-img {
            width: 17px;
            height: 17px;
          }
        }
      }
      .student-text {
        height: 17px;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 17px;
        text-align: left;
      }
      .teacher-text {
        height: 17px;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 17px;
      }
    }
    .stop-further {
      width: 72px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #ff6e0d;
      border-radius: 14px;
      font-size: 12px;
      color: #ffffff;
      // margin-right: 15px;
      position: absolute;
      top: 14px;
      right: 76px;
    }
    .switch-path-btn {
      width: 60px;
      height: 26px;
      background: #ffdecc;
      border-radius: 15px 0px 0px 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 16px;
      right: 0;
      .switch-path-btn-text {
        height: 17px;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        color: #EB1700;
        line-height: 17px;
        position: relative;
        padding-left: 3px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      margin-right: 14px;
      /deep/ .van-circle {
        width: 45px;
        height: 45px;
      }
      /deep/ .van-circle__text {
        font-size: 13px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        color: #000000;
      }
    }
  }
  .tab-viewtwo {
    width: 100%;
    //min-height: 113px;
    background: #ffffff;
    box-shadow: 2px 3px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 0 0 5px 5px;
    padding: 10px 10px 0px 10px;
    display: flex;
    flex-wrap: wrap;
    .tab-item {
      width: 33%;
      margin-bottom: 16px;
      text-align: center;
      position: relative;
      .tab-item-left {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 5px;
        /deep/ .van-circle {
          width: 45px;
          height: 45px;
        }
        /deep/ .van-circle__text {
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          color: #333333;
        }
      }
      .item-img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 45px;
        margin-bottom: 5px;
        font-size: 30px;
        font-weight: Bold;
        color: #EB1700;
      }
      .text {
        font-size: 12px;
        font-weight: Medium;
        color: #1f333f;
        .text-item {
          font-size: 11px;
          font-weight: Medium;
          color: #666666;
        }
      }
      .count {
        position: absolute;
        top: -5px;
        right: 20px;
        background: #ff0000;
        text-align: center;
        color: white;
        border-radius: 50%;
        font-size: 10px;
        font-weight: bold;
        min-width: 14px;
        height: 14px;
        padding: 0 3px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.my-line {
  background: #e0e2e7;
}
.my-line::after {
  content: '';
  width: 100%;
  height: 1px;
  display: block;
  margin: 0 auto;
  border-radius: 2px;
}
.study-progress-container {
  position: relative;
  width: 100%;
  height: 39px;
  border-radius: 0px 0px 12px 12px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  .study-progress-tips-container {
    height: 17px;
    font-size: 12px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 17px;
    display: flex;
    align-items: center;
    .dot {
      width: 4px;
      height: 4px;
      background: #EB1700;
      margin: 0px 7px 0 12px;
    }
    .text {
      width: 150px;
      height: 17px;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 17px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: left;
    }
  }
  .go-study-btn {
    width: 60px;
    height: 23px;
    background: #EB1700;
    border-radius: 12px;
    position: absolute;
    top: 50%;
    right: 18px;
    transform: translateY(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    .go-study-text {
      height: 17px;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 17px;
    }
  }
  .stop-further {
    width: 66px;
    height: 23px;
    line-height: 23px;
    text-align: center;
    background: #EB1700;
    border-radius: 14px;
    font-size: 12px;
    color: #ffffff;
    // margin-right: 15px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 88px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/StudyInfo.vue